import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { useMemo } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
var AwardsSection = function AwardsSection() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useTranslation2 = useTranslation(),
    tLong = _useTranslation2.tLong;
  var awards = useMemo(function () {
    return [{
      title: tShort("about_us/awards_item1", {
        ns: "web_common"
      }),
      img: "/assets/images/about-us/award1.svg",
      width: 200,
      height: 60,
      alt: tLong("about_us/award_item_alt_1")
    }, {
      title: tShort("about_us/awards_item2", {
        ns: "web_common"
      }),
      img: "/assets/images/about-us/award2.svg",
      width: 180,
      height: 50,
      alt: tLong("about_us/award_item_alt_2")
    }, {
      title: tShort("about_us/awards_item3", {
        ns: "web_common"
      }),
      img: "/assets/images/about-us/award3.svg",
      width: 150,
      height: 150,
      alt: tLong("about_us/award_item_alt_3")
    }, {
      title: tShort("about_us/awards_item4", {
        ns: "web_common"
      }),
      img: "/assets/images/about-us/award4.svg",
      width: 200,
      height: 95,
      alt: tLong("about_us/award_item_alt_4")
    }];
  }, [tLong, tShort]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "px-6 pt-12 flex flex-col gap-8 md:pt-[104px] md:max-w-[1152px] md:mx-auto md:px-0 md:gap-[70px]"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-center text-primary text-3xl font-bold md:text-[40px] md:leading-[56px]"
  }, tShort("about_us/awards_title", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 md:flex-row"
  }, awards.map(function (award, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AwardItem, _extends({
      key: award.title + i
    }, award)));
  }))));
};
var AwardItem = function AwardItem(_ref) {
  var title = _ref.title,
    img = _ref.img,
    width = _ref.width,
    height = _ref.height,
    alt = _ref.alt,
    key = _ref.key;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 md:flex-1 md:max-w-[275px]",
    key: key
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-full h-[160px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + img,
    alt: alt,
    width: width,
    height: height
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#576678] text-center text-base font-normal leading-8"
  }, title));
};
export default AwardsSection;